module.exports = __webpack_public_path__ + "media/asset-2.3d022958.webm";